module.exports = __webpack_public_path__ + "img/opensearch.49f89aaa.svg";